/**
 * Système de logging conditionnel pour EFAFC Website
 * Les logs sont automatiquement désactivés en production
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  error: (...args) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
  
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  
  table: (...args) => {
    if (isDevelopment) {
      console.table(...args);
    }
  },

  // Méthode spéciale pour les logs d'API (toujours actifs en dev, désactivés en prod)
  api: (message, data) => {
    if (isDevelopment) {
      console.log(`[API] ${message}`, data || '');
    }
  },

  // Méthode pour les logs Firebase (toujours actifs en dev, désactivés en prod)
  firebase: (message, data) => {
    if (isDevelopment) {
      console.log(`[Firebase] ${message}`, data || '');
    }
  }
};

export default logger;
